const actions = {
  REQUESTING: 'Invoice2Items/REQUESTING',
  RESPONSE_ERROR: 'Invoice2Items/RESPONSE_ERROR',

  FETCH_INVOICE2ITEMS: 'Invoice2Items/FETCH',
  LIST_INVOICE2ITEM: 'Invoice2Item/LIST',

  FETCH_INVOICE2ITEM: 'Invoice2Item/FETCH',
  NEW_INVOICE2ITEM: 'Invoice2Item/NEW',
  EDIT_INVOICE2ITEM: 'Invoice2Item/EDIT',
  RESET_INVOICE2ITEM: 'Invoice2Item/RESET',

  SAVE_INVOICE2ITEM: 'Invoice2Item/SAVE',
  SAVE_INVOICE2ITEM_RECIEVED: 'Invoice2Item/SAVE_INVOICE2ITEM_RECIEVED',

  DELETE_INVOICE2ITEM: 'Invoice2Item/DELETE',
  DELETE_INVOICE2ITEM_RECIEVED: 'Invoice2Item/DELETE_RECIEVED',
}

export default actions
